import React, { Component } from 'react';
import IconBackspace from '../../assets/img/keyboard-ic-backspace.png';
import IconEnter from '../../assets/img/keyboard-ic-enter.png';
import IconClear from '../../assets/img/keyboard-ic-clear.png';
import {
  KeyboardContainer,
  KeyboardInput,
  KeyboardContent,
  KeyboardNum,
  KeyboardActions,
  KeyboarButton,
} from './style';

class Keyboard extends Component {
  constructor(props) {
    super(props);
    this.keyPress = this.keyPress.bind(this);
    this.keyEnter = this.keyEnter.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleCelan = this.handleCelan.bind(this);
    this.handleSlice = this.handleSlice.bind(this);
    this.state = {
      result: '',
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keyPress);
    document.addEventListener('keyup', this.keyEnter);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyPress);
    document.removeEventListener('keyup', this.keyEnter);
  }

  keyPress(e) {
    const elementInput = document.getElementById('input');
    const characters = String.fromCharCode(e.which);
    if (
      /[0-9, a-i, `, , ]/.test(characters) &&
      e.target.tagName.toUpperCase() != 'INPUT'
    ) {
      elementInput && elementInput.focus();
    } else if (
      !/[0-9, a-i, `, , ]/.test(characters) &&
      elementInput.matches(':focus')
    ) {
      e.preventDefault();
    }
  }

  keyEnter(e) {
    const elementInput = document.getElementById('input');
    const enter = document.getElementById('keyenter');
    if (e.keyCode == 13 && elementInput.matches(':focus')) {
      enter.click();
    }
  }

  handleClick(event) {
    const value = event.target.value;
    let result = this.state.result;
    this.setState({ result: result + value });
  }

  handleValue(result) {
    this.setState({
      result: result.target.value,
    });
  }

  handleCelan() {
    this.setState({
      result: '',
    });
  }

  handleSlice() {
    this.setState({
      result: this.state.result.slice(0, -1),
    });
  }

  render() {
    return (
      <KeyboardContainer>
        <KeyboardInput
          value={this.state.result}
          onChange={result => this.handleValue(result)}
          placeholder="Código de Produto"
          name="keyboard"
          id="input"
        />
        <KeyboardContent>
          <KeyboardNum>
            <KeyboarButton
              data-value="7"
              value="7"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="8"
              value="8"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="9"
              value="9"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="4"
              value="4"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="5"
              value="5"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="6"
              value="6"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="1"
              value="1"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="2"
              value="2"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="3"
              value="3"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="0"
              value="0"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value="00"
              value="00"
              onClick={this.handleClick}
            />
            <KeyboarButton
              data-value=","
              value=","
              onClick={this.handleClick}
            />
          </KeyboardNum>
          <KeyboardActions>
            <KeyboarButton actions onClick={this.handleSlice}>
              <img src={IconBackspace} alt="" />
            </KeyboarButton>
            <KeyboarButton actions onClick={this.handleCelan}>
              <img src={IconClear} alt="" />
            </KeyboarButton>
            <KeyboarButton
              onClick={this.props.callBack}
              id="keyenter"
              actions
              enter
            >
              <img src={IconEnter} alt="" />
            </KeyboarButton>
          </KeyboardActions>
        </KeyboardContent>
      </KeyboardContainer>
    );
  }
}

export default Keyboard;
